const validarpermiso = (collection, action, permisos) => {
  const permisosresult = permisos?.filter(
    (permission) =>
      permission.collection === collection && permission.action === action
  );

  if (permisosresult.length > 0) {
    return true;
  } else {
    return false;
  }
};
export default validarpermiso;

export const formatUser = (user) => {
  if (!user) return "N/A";
  return `${user.first_name || ""} ${user.last_name || ""} (${
    user.email || "Sin email"
  })`.trim();
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleString();
};

export const getStatusColor = (estado) => {
  const colors = {
    creada: "blue",
    anulada: "red",
    pagada: "green",
    pendiente: "gold",
  };
  return colors[estado] || "default";
};

export const calculateTotals = (productos) => {
  return productos?.reduce(
    (acc, producto) => {
      const cantidad = producto.cantidad || 0;
      const precioUnitario = producto.precio_unitario || 0;
      const impuesto = producto.producto?.grupo?.impuesto || 0;

      const subtotal = cantidad * precioUnitario;
      const impuestoValor = (subtotal * impuesto) / 100;

      return {
        subtotal: acc.subtotal + subtotal,
        impuestoTotal: acc.impuestoTotal + impuestoValor,
        total: acc.total + (subtotal + impuestoValor),
      };
    },
    { subtotal: 0, impuestoTotal: 0, total: 0 }
  );
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(amount);
};

/**
 * Mapea símbolos de moneda a códigos ISO 4217 válidos
 * @param {string} symbol - Símbolo de moneda
 * @returns {string} Código ISO de moneda
 */
export const getCurrencyCode = (symbol) => {
  const currencyMap = {
    "₡": "CRC", 
    "$": "USD", 
    "€": "EUR", 
    "£": "GBP", 
    "¥": "JPY", 
    "COP": "COP", 
    "PAB": "PAB", 
    "MXN": "MXN", 
  };
  return currencyMap[symbol] || "PAB";
};

/**
 * Formatea un precio usando el símbolo de moneda del store
 * @param {number} price - Precio a formatear
 * @param {string} signoMoneda - Símbolo de moneda del store
 * @param {string} locale - Locale para el formateo (default: "es-PA")
 * @returns {string} Precio formateado
 */
export const formatPrice = (price, signoMoneda, locale = "es-PA") => {
  const currencyCode = getCurrencyCode(signoMoneda);
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  }).format(price);
};

/**
 * Trunca un serial a 18 dígitos si omitir1 es true y el serial tiene 19 dígitos
 * @param {string} serial - Serial a truncar
 * @param {boolean} omitir1 - Estado de omitir1 del store
 * @returns {string} Serial truncado o el original
 */
export const truncateSerial = (serial, omitir1) => {
  if (
    omitir1 === true &&
    typeof serial === "string" &&
    serial.length === 19
  ) {
    return serial.substring(0, 18);
  }
  return serial;
};
